import { createAction, props } from '@ngrx/store';
import { SelectItem } from 'primeng/api';
import { AdminLocationModel } from 'src/app/model/admin/location';
import { BaseModalModel } from 'src/app/model/core/base-modal';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

const adminLocationLabels = {
  SET_QUERY_SEARCH: 'ADMIN_LOCATION_SET_QUERY_SEARCH',
  SET_RESULT: 'ADMIN_LOCATION_SET_RESULT',
  PUT_LOCATION: 'ADMIN_LOCATION_PUT',
  PATCH_LOCATION: 'ADMIN_LOCATION_PATCH',
  SET_LOCATION: 'ADMIN_LOCATION_SET',
  SET_LOCATION_DEFAULT: 'ADMIN_LOCATION_SET_DEFAULT',
  SET_ALL_DEFAULT: 'ADMIN_LOCATION_SET_ALL_DEFAULT',
};

export const adminLocationActions = {
  setQuerySerch: createAction(
    adminLocationLabels.SET_QUERY_SEARCH,
    props<{ items: SelectItem<KhuyanaSelectItemModel>[] }>()
  ),
  setResultAction: createAction(
    adminLocationLabels.SET_RESULT,
    props<{ result: AdminLocationModel[] }>()
  ),
  putLocationAction: createAction(
    adminLocationLabels.PUT_LOCATION,
    props<AdminLocationModel>()
  ),
  patchLocationAction: createAction(
    adminLocationLabels.PATCH_LOCATION,
    props<AdminLocationModel>()
  ),
  setLocationAction: createAction(
    adminLocationLabels.SET_LOCATION,
    props<BaseModalModel<AdminLocationModel>>()
  ),
  setLocationDefaultAction: createAction(
    adminLocationLabels.SET_LOCATION_DEFAULT,
    props<any>()
  ),
  setAllDefaultAction: createAction(
    adminLocationLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
